<template>
  <div class="sf-modal-white sf-modal sf-modal-top sf-modal-xs">
    <div class="sf-modal-backdrop">
      <div class="sf-modal-container">
        <div class="sf-modal-inner">
          <div class="sf-modal-header">
            <div class="sf-modal-back sf-invisible"></div>
            <div class="sf-modal-title">
              {{
                I18n.t('user.edit_user_access', { company_name: companyName })
              }}
            </div>
            <div class="sf-modal-close" @click="closeModal"></div>
          </div>
          <form class="sf-form sf-pad-3">
            <div class="sf-form-label">{{ I18n.t('common.name') }}</div>
            <input
              v-model="name"
              class="sf-form-input sf-full sf-below-2"
              type="text"
            />
            <div class="sf-form-label">{{ I18n.t('common.email') }}</div>
            <input
              :value="email"
              class="sf-form-input sf-full sf-below-2"
              disabled="disabled"
              type="text"
            />
            <div v-if="canEditRole">
              <div class="sf-form-label">{{ I18n.t('common.role') }}</div>
              <div class="sf-form-select-wrapper sf-full sf-below-3">
                <select v-model="role" class="sf-form-select">
                  <option v-if="firmEditable" value="firm">
                    {{ I18n.t('role.staff_contributor') }}
                  </option>
                  <option v-if="externalEditable" value="external">
                    {{ I18n.t('role.external_contributor') }}
                  </option>
                  <option value="customer">
                    {{ I18n.t('role.pulse_user') }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="firmSupportsAdminUsers" class="sf-level sf-below-3">
              <SfCheckbox
                v-model="usersAdmin"
                :label="I18n.t('user.admin_user_permissions_label')"
              ></SfCheckbox>
            </div>
            <div class="sf-level sf-level-center">
              <div class="sf-btn sf-btn-danger" @click="deleteUserRole">
                {{ I18n.t('common.remove') }}
              </div>
              <div class="sf-btn sf-btn-success" @click="submitUser">
                {{ I18n.t('common.save') }}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/index'
import { SfCheckbox } from '@silverfin/ui-components'

const EditUserModal = {
  components: {
    SfCheckbox,
  },
  props: [
    'user',
    'canEditFirmUsers',
    'canEditExternalContributors',
    'firmSupportsAdminUsers',
    'companyName',
  ],

  data() {
    // Assign locally to avoid direct mutation
    return {
      id: this.user.userId,
      name: this.user.userName,
      email: this.user.userEmail,
      role: this.user.role,
      external: this.user.userExternal,
      usersAdmin: this.user.usersAdmin,
    }
  },

  emits: ['refresh-users'],

  computed: {
    externalEditable() {
      return (
        this.canEditExternalContributors &&
        this.external &&
        (this.role === 'external' || this.role === 'customer')
      )
    },

    firmEditable() {
      return (
        this.canEditFirmUsers &&
        !this.external &&
        (this.role === 'firm' || this.role === 'customer')
      )
    },

    canEditRole() {
      return this.externalEditable || this.firmEditable
    },
  },

  methods: {
    closeModal() {
      this.$el.style.display = 'none'
    },

    submitUser() {
      api
        .updateUser(this.id, {
          id: this.id,
          name: this.name,
          email: this.email,
          role: this.role,
          external: this.external,
          usersAdmin: this.usersAdmin,
        })
        .then(() => {
          this.closeModal()
          this.$emit('refresh-users')
        })
    },

    deleteUserRole() {
      api.deleteUserRole(this.id).then(() => {
        this.$emit('refresh-users')
      })
      this.closeModal()
    },
  },
}

export default EditUserModal
</script>
